import { NavLink, NavLinkProps } from "react-router-dom";
import { Menu } from "@arco-design/web-react";
import { IconProps } from "@arco-design/web-react/icon";
import { cssVariables } from "../../utils";
import { ReactNode } from "react";

const MenuItem = Menu.Item;

interface MenuNavLinkProps extends NavLinkProps {
  label?: string;
  icon?: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<unknown>>;
  menuItemChildren?: ReactNode;
}

export const MenuNavLink = ({ label, menuItemChildren, icon: Icon, ...props }: MenuNavLinkProps) => {
  return (
    <NavLink {...props}>
      {({ isActive }) => (
        <MenuItem
          key={props.to.toString()}
          style={{
            backgroundColor: cssVariables.headerColor,
            color: cssVariables.headerTextColor,
          }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              borderBottom: isActive ? '1px solid currentColor' : 'none',
            }}
          >
            {Icon && <Icon style={{ color: cssVariables.headerTextColor }} />}
            {menuItemChildren || label}
          </span>
        </MenuItem>
      )}
    </NavLink>
  )
}